import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import { Card, CardContent, Typography, Stack, Divider } from "@mui/material";
import { formatCurrency, getRiskBinLabel } from "../../helpers";

import RiskLabel from "./riskLabel";

const MunicipalityCard = memo(function MunicipalityCard({
  name,
  propertiesCount,
  totalCapitalAtRisk,
  totalContractPrice,
  avgFloodRisk,
  avgFireRisk,
  avgEarthquakeRisk,
  fireBin,
  floodBin,
  earthquakeBin,
  onClick,
}) {
  const { t } = useTranslation();
  return (
    <Card
      onClick={onClick}
      sx={{
        p: 2,
        cursor: "pointer",
        borderRadius: 2,
        overflow: "hidden",
        border: "1px solid #eee",
        boxShadow: "none",
        transition: "transform 120ms ease, box-shadow 120ms ease",
        "&:hover": {
          boxShadow: "0 4px 8px rgba(0,0,0,0.03), 0 2px 4px rgba(0,0,0,0.02)",
        },
      }}
    >
      <CardContent sx={{ padding: "0px !important" }}>
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: 600, lineHeight: 1.25, mb: 1, letterSpacing: 0.2 }}
        >
          {name || t("common.noData")}
        </Typography>

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="baseline"
          sx={{ mb: 0.5 }}
        >
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            {t("portfolioMap.totalInsuredProperties")}
          </Typography>
          <Typography variant="body1">{propertiesCount ?? 0}</Typography>
        </Stack>

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="baseline"
          sx={{ mb: 0.5 }}
        >
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            {t("portfolioMap.totalCapitalAtRisk")}
          </Typography>
          <Typography variant="body1">
            {formatCurrency(totalCapitalAtRisk)}
          </Typography>
        </Stack>

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="baseline"
        >
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            {t("portfolioMap.totalContractPrice")}
          </Typography>
          <Typography variant="body1">
            {formatCurrency(totalContractPrice)}
          </Typography>
        </Stack>

        <Divider sx={{ my: 1.5 }} />

        <Stack direction="row" spacing={2}>
          <RiskLabel
            label={t("risks.fire")}
            value={avgFireRisk}
            bin={fireBin}
            tooltip={t("portfolioMap.avgRiskTooltip", {
              risk: t("risks.fire"),
              bin: getRiskBinLabel(fireBin, t),
            })}
          />
          <RiskLabel
            label={t("risks.flood")}
            value={avgFloodRisk}
            bin={floodBin}
            tooltip={t("portfolioMap.avgRiskTooltip", {
              risk: t("risks.flood"),
              bin: getRiskBinLabel(floodBin, t),
            })}
          />
          <RiskLabel
            label={t("risks.earthquake")}
            value={avgEarthquakeRisk}
            bin={earthquakeBin}
            tooltip={t("portfolioMap.avgRiskTooltip", {
              risk: t("risks.earthquake"),
              bin: getRiskBinLabel(earthquakeBin, t),
            })}
          />
        </Stack>
      </CardContent>
    </Card>
  );
});

export default MunicipalityCard;
